import { render } from "./FourZeroFourView.vue?vue&type=template&id=40897e5d&scoped=true"
import script from "./FourZeroFourView.vue?vue&type=script&lang=js"
export * from "./FourZeroFourView.vue?vue&type=script&lang=js"

import "./FourZeroFourView.vue?vue&type=style&index=0&id=40897e5d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40897e5d"]])

export default __exports__